<template>
  <el-image
    :src="src"
    :style="`width: ${width}; height: ${height}`"
    style="border-radius: 8px; border: 1px solid gray;"
  >
    <div
      slot="error"
      class="image-slot h-100"
      style="display: flex; align-items: center; justify-content: center;"
    >
      <i class="el-icon-picture-outline" />
    </div>
  </el-image>
</template>

<script>
export default {
  props: {
    src: String,
    width: String,
    height: String
  },
  computed: {
  },
  methods: {},
};
</script>

<style lang="scss"></style>
